import * as React from 'react';
import GloLayout from 'lowcode/common/GloLayout';
import { getLang } from 'lowcomp/plugins/member/utils';
import RewardsRedeemed from 'lowcomp/plugins/member/common/RewardsRedeemed';
import { useMemberTimeStore } from 'lowcode/utils/context/memberTimeZone';
import { EcoProvider } from './context';
import EcoCreditRules from './EcoCreditRule';
import styles from './index.module.scss';
import FullScreenModal from './FullScreenModal';
import lang from './lang';
import getLocal from '@/app/utils/getLocal';
import { getIssuedCoupons } from '@/service/vip';
import { injectNotes } from '@/components/EcoCredits/utils';

export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    const {
        list = [],
        title,
        titleColor,
        subTitle,
        subTitleColor,
        memberBgColor,
        pathUrl,
        navUnSelectedColor,
        navSelectedColor,
        themeColor,
        fontColor,
        pointsColor,
        loginType,
    } = data;

    const { locale } = getLocal();
    const t = getLang(lang, locale);

    const [issuedCoupon, setIssuedCoupon] = React.useState<any[]>([]);
    const [showPage, setShowPage] = React.useState('');
    const { timezoneList } = useMemberTimeStore();
    const styleComp: any = {
        '--member-h-titleColor': titleColor,
        '--member-h-subTitleColor': subTitleColor,
        '--member-h-navColor': navUnSelectedColor,
        '--member-h-navSelectedColor': navSelectedColor,
        '--member-h-themeColor': themeColor,
        '--member-h-fontColor': fontColor,
        '--member-h-pointsColor': pointsColor,
        backgroundColor: memberBgColor,
    };

    const customColor = {
        bgColor: memberBgColor,
        themeColor: themeColor,
    };

    /**
     * 查询issued优惠券兑换记录
     */
    const queryIssuedRewards = async () => {
        const res = await getIssuedCoupons(locale as string);
        if (res?.code === '0') {
            const coupons = injectNotes(res?.data || [], t, locale as string, timezoneList);
            setIssuedCoupon(coupons || []);
        }
    };

    const closeModal = () => {
        setShowPage('');
    };

    return (
        <GloLayout id={id} className={`temp-member-redeem temp-hide ${styles.content}`}>
            <EcoProvider>
                <div
                    className="temp-member-product-scene-h ef-content GtmModuleData-section"
                    style={styleComp}
                    data-section-id={'Member-Redeem'}
                    data-section-title={title || 'Member-Redeem'}
                >
                    <EcoCreditRules
                        title={title}
                        subTitle={subTitle}
                        pathUrl={pathUrl}
                        setShowPage={setShowPage}
                        customColor={customColor}
                        bgColor={memberBgColor}
                        isEditStatus={isEditStatus}
                        id={id}
                        customStyle={styleComp}
                        loginType={loginType}
                    />
                    {showPage?.startsWith('points_modal') && (
                        <FullScreenModal visible className={showPage} style={{ ...styleComp, background: '#f5f5f5' }} closeModal={closeModal}>
                            <EcoCreditRules
                                modal
                                refershData={() => {}}
                                setShowPage={setShowPage}
                                customColor={customColor}
                                pathUrl={pathUrl}
                                loginType={loginType}
                                defauleActiveTab={(showPage?.includes('$') && showPage?.split('$').pop()) || undefined}
                            />
                        </FullScreenModal>
                    )}
                    {showPage?.startsWith('coupon_modal') && (
                        <FullScreenModal
                            visible={showPage?.startsWith('coupon_modal')}
                            className={showPage}
                            style={{ background: '#f8f8f8' }}
                            closeModal={closeModal}
                            afterOpen={() => {
                                queryIssuedRewards();
                            }}
                        >
                            <RewardsRedeemed
                                modal
                                defaultSelectKey={(showPage?.includes('$') && showPage?.split('$').pop()) || '1'}
                                issuedCoupon={issuedCoupon}
                            />
                        </FullScreenModal>
                    )}
                </div>
            </EcoProvider>
        </GloLayout>
    );
}
